<section id="content" class="project-list" *ngIf="lang">
  <div class="page page-profile">

    <!-- page header -->
    <div class="pageheader">
      <h2>{{ lang.projects }}
      </h2>
      <div class="page-bar">
        <ul class="page-breadcrumb">
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.DASHBOARD"><i class="fa fa-home"></i>
              {{AppSettings.SITE_TITLE | titlecase}}</a>
          </li>
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.Servicing_List">{{ lang.projects }}
            </a>
          </li>
        </ul>
      </div>
    </div>

    <!-- page content -->
    <div class="pagecontent">

      <!-- row -->
      <div class="row">
        <div class="col-md-12">
          <div class="tile tile-simple">

            <!-- tile body -->
            <div class="tile-body" [ngSwitch]="pageView">
              <div role="tabpanel" *ngSwitchCase="'list'">

                <ul class="nav nav-tabs tabs-dark" role="tablist">
                  <li role="presentation" [ngClass]="{ 'active':generalTab==='activeTab'}"><a href="#generalTab"
                      aria-controls="feedTab" role="tab" data-toggle="tab">All Projects</a></li>
                  <li role="presentation" [ngClass]="{ 'active':operatingTab==='activeTab'}"><a href="#renovateTab"
                      aria-controls="renovateTab" role="tab" data-toggle="tab">Renovate Projects</a></li>
                </ul>


                <div class="tab-content">
                  <div role="tabpanel" class="tab-pane active" id="generalTab">
                    <div class="row p-12">

                      <div class="col-sm-2">
                        <div class="social-icons">

                          <a class="plus-add" (click)="addEditProject()" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Add">
                            <i class="fa fa-plus"></i>
                          </a>

                          <a class="plus-export" data-toggle="modal" data-target="#datatableExport1"
                            data-options="splash-2 splash-ef-4" title="Export"> 
                            <span class="glyphicon glyphicon-export"></span>
                          </a>

                          <a class="plus-import" data-toggle="modal" data-target="#datatableExport2" data-action="show"
                            data-id="" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Import">
                            <span class="glyphicon glyphicon-import"></span>
                          </a>

                          <a class="plus-copy" (click)="multiDuplicate()" data-action="show" data-id="" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Duplicate">
                            <span class="glyphicon glyphicon-file"></span>
                          </a>

                          <a class="plus-delete" *ngIf="deleteOption" (click)="multiDelete()" 
                          [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Delete">
                            <span class="glyphicon glyphicon-trash"></span>
                          </a>

                        </div>
                      </div>

                      <div class="col-sm-8">
                        <div> 

                          <div class="row">
                            <div class="col-sm-2">
                              <select class="form-control" name="pyear" style="margin-right: 15px;" onchange="filterme2()">
                                <option value="">{{lang?.select_year}}</option>
                                <option value="2021" selected="">2021</option>
                                <option value="2020">2020</option>
                                <option value="2019">2019</option>
                                <option value="2018">2018</option>
                                <option value="2017">2017</option>
                                <option value="2016">2016</option>
                                <option value="2015">2015</option>
                                <option value="2014">2014</option>
                                <option value="2013">2013</option>
                                <option value="2012">2012</option>                        
                              </select>
                            </div>

                            <div class="col-sm-2">
                              <input onchange="filterme()" type="checkbox" id="col1" name="type" value="OPEN"> {{lang?.open}}
                            </div>

                            <div class="col-sm-2">
                              <input onchange="filterme()" type="checkbox" id="col2" name="type" value="CLOSED"> {{lang?.closed}}
                            </div>
                            
                            <div class="col-sm-2">
                              <input onchange="filterme1()" type="checkbox" id="col2" name="invstatus" value="Invoiced and Not Paid"> {{lang?.not_invoiced}}
                            </div>
                            
                            <div class="col-sm-2">
                              <input onchange="filterme1()" type="checkbox" id="col1" name="invstatus" value="Invoiced and Paid"> {{lang?.invoiced_paid}}
                            </div>                            

                          </div>

                        </div>
                      </div>
    
                      <div  class="col-sm-2">
                        <input
                        style="float:right;"
                        #search
                        id="search"
                        type="text"
                        class="form-control"
                        [placeholder]="lang?.search"
                        aria-label="Search"
                        aria-describedby="basic-addon1"
                      />                        
                      </div> 
                  
                    </div>

                    <div ng-app="testmyApp" class="form-group" style="overflow: auto;">
                      <table datatable [dtOptions]="datatableOptions1" class="table-striped table-sm row-border hover"
                        id="table1" *ngIf="project">
                        <thead>
                          <tr>
                            <th>Hidden.No</th>
                            <th>
                              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                                <input type="checkbox"><i></i>
                              </label>
                            </th>
                            <th>{{ lang.no }}</th>
                            <th>{{ lang.projectCode }}</th>
                            <th>{{ lang.projectClass }}</th>
                            <th>{{ lang.projectCategory }}</th>
                            <th>{{ lang.projectTitle }}</th>
                            <th>{{ lang.customer }}</th>
                            <th>{{ lang.responsible }}</th>
                            <th>{{ lang.startDate }}</th>
                            <th>{{lang?.expected_delivery_date}}</th>
                            <th>{{ lang.closingDate }}</th>
                            <th>{{ lang.completion }}</th>
                            <th>{{ lang.margin }}</th>
                            <th>{{ lang.status }}</th>
                            <th>{{ lang.payemntRefresh }}</th>
                            <th>{{ lang.action }}</th>
                          </tr>
                        </thead>
                        <tbody dragula="project" [(dragulaModel)]="project">
                          <tr *ngFor="let record of project let i = index" id="{{record.id}}">
                            <td>{{i+1}}</td>
                            <td></td>
                            <td>{{i+1}}</td>
                            <td>{{ record.code }}</td>
                            <td></td>
                            <td></td>
                            <td>{{ record.title }}</td>
                            <td>{{ record.company }}</td>
                            <td>{{ record.customer_id }}</td>
                            <td>{{ record.start_date }}</td>
                            <td>{{ record.div_date }}</td>
                            <td>{{ record.end_date }}</td>
                            <td>{{ record.customer_id }}</td>
                            <td>{{ record.amount }}</td>
                            <td></td>
                            <td style="width: 30%;"> 
                              <select class="form-control" name="payment_reference">
                                <option value="1" style="background: #FFFF00">Not Invoiced</option>
                                <option value="2" style="background: #FF0000">Invoiced and Not Paid</option>
                                <option value="3" style="background: #D5F5E3">Invoiced and Paid</option>
                              </select>
                            </td>
                            <td>
                              <div class="btn-group dropup">

                                <button type="button" class="btn btn-info dropdown-toggle circle_btn"
                                  data-toggle="dropdown" aria-expanded="false"><i class="fa fa-tasks"></i></button>

                                <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">
                                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a class="delete_action" (click)="delete(record.id)"><i
                                    class="fa fa-trash"></i> Erase</a></li>

                                    <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                                      <a (click)="addEditProject(record.id,record)" href="javascript:void(0)" class="edit_action"><i class="fa fa-edit"></i> Modify</a>
                                    </li>

                                
                                      <li><a [routerLink]="['/'+AppFrontRoutes.PROJECT_VIEW+'/'+record.id]"
                                        class="view_action"><i class="glyphicon glyphicon-eye-open"></i>View</a>
                                    </li>

                                    <li><a [routerLink]="['/'+AppFrontRoutes.QUALIFIED_TEACHER_VIEW+'/'+record.id]"
                                      class="view_action"><i class="glyphicon glyphicon-euro"></i>Invoice Details</a>
                                  </li>

                                  <li><a [routerLink]="['/'+AppFrontRoutes.PROJECT_VIEW
                                    +'/'+record.id]"
                                    class="delete_action"><i class="glyphicon glyphicon-stop"></i>Close</a>
                                </li>
                                </ul>
                              </div>
                            </td>

                          </tr>
                        </tbody>

                      </table>
                    </div>
                  </div>

                  <div role="tabpanel" class="tab-pane" id="renovateTab">
                         <div ng-app="testmyApp" class="form-group" style="overflow: auto;">
                      <table datatable [dtOptions]="datatableOptions1" class="table-striped table-sm row-border hover"
                        id="table2" *ngIf="closed_projects">
                        <thead>
                          <tr>
                            <th>Hidden.No</th>
                            <th>
                              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                                <input type="checkbox"><i></i>
                              </label>
                            </th>
                            <th>{{ lang.no }}</th>
                            <th>{{ lang.parentProjectCode }}</th>
                            <th>{{ lang.projectClass }}</th>
                            <th>{{ lang.projectCategory }}</th>
                            <th>{{ lang.projectTitle }}</th>
                            <th>{{ lang.customer }}</th>
                            <th>{{ lang.responsible }}</th>
                            <th>{{ lang.startDate }}</th>
                            <th>Expected Delivery Date</th>
                            <th>{{ lang.expectedHours }}</th>
                            <th>{{ lang.closingDate }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let crecord of closed_projects let i = index" id="{{crecord.id}}">
                            <td>{{i+1}}</td>
                            <td></td>
                            <td>{{i+1}}</td>
                            <td>
                              <a href="javascript:void(0);" class="pull-right common-newicons icon-colors3 renovate_project_click" data-action="delete"  (click)="delete_renovate(crecord.id)">
                                <span class="glyphicon glyphicon-trash"></span>
                              </a>
                              <a href="javascript:void(0);" class="pull-right common-newicons icon-colors4 renovate_project_click" data-action="new" data-id="867">
                                <span class="glyphicon glyphicon-repeat"></span>
                              </a>
                            </td>
                            <td>{{ crecord.class }}</td>
                            <td>{{ crecord.category }}</td>
                            <td>{{ crecord.title }}</td>
                            <td>{{ crecord.customer_id }}</td>
                            <td>{{ crecord.emp_id }}</td>
                            <td>{{ crecord.start_date }}</td>
                            <td>{{ crecord.div_date }}</td>
                            <td>{{ crecord.hours }}</td>
                            <td>{{ crecord.end_date }}</td>
                          </tr>
                        </tbody>

                      </table>
                    </div>
                  </div>

                  
<!-- 
                                 
                  <ejs-gantt id="GanttSample" 
                  [dataSource]="data1" 
                  height= "450px"
                  width="800px"
                  [taskFields]= "taskfield">
                </ejs-gantt> -->



                </div>

              </div>



            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</section>


<div class="modal splash fade" id="datatableExport1" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ lang?.selectColumns }}
        </h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export1_select_deselect_all($event)"><i></i> {{ lang?.selectAll }}
            </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>{{ lang?.activeColumns }}
            </h2>

            <div class="row" *ngFor="let option of datatableCols1">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export1_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn1" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">{{ lang?.close }}</button>
      </div>

    </div>
  </div>
</div>


<div class="modal splash fade" id="datatableExport2" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- <div class="modal-header">
          <h3 class="modal-title custom-font">IMPORT HOURLY DATA</h3>
          <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span aria-hidden="true">&times;</span>
          </button>      
        </div>
         -->

      <div class="modal-header">
        <h4 class="modal-title pull-left uppercase">{{ lang?.importTitle }}
        </h4>
        <button type="button" class="close pull-right" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>


      <div class="modal-body column_export">
        <div class="row">
          <form>
            <input type="file" class="filestyle" id="file" name='file' data-buttonText="Choose file"
              (change)="onPhotoPickerChange($event)" appFileDesign>
            <font style="vertical-align: inherit;">
              <font style="vertical-align: inherit;"><a href="http://vmi313621.contaboserver.net/Software_backend/uploads/csv_files/template_qualified_teachers.csv" download="">Click here to dowload to csv format file</a> </font>
            </font>
          </form>
        </div>
      </div>

      <div class="modal-footer">
        <!-- <div id="datatableExportBtn2" class="export_dynamic_btn">
          </div> -->
        <button type="button" class="btn btn-primary" (click)="onclick()">{{ lang?.submit }}</button>
        <!-- <button class="btn btn-warning" data-dismiss="modal">Close</button>-->
        <button type="button" class="btn btn-warning" data-dismiss="modal">{{ lang?.close }}</button>

      </div>
    </div>
  </div>
</div>

<div class="modal splash fade" id="datatableExport3" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ mLang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export2_select_deselect_all($event)"><i></i> {{ mLang?.selectAll }} </label>
        </div>                                                                                                                                                                                                                                                                                                
        <div class="row flexs">

          <div class="active-left">
            <h2>{{ mLang?.activeColumns }}</h2>

            <div class="row" *ngFor="let option of datatableCols2">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export1_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn2" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">Close</button>
      </div>

    </div>
  </div>
</div>
<script type="text/javascript">

</script>